/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

import isInputCorrect from "src/utils/ResultValidationHelper";

import ResultDropdown from "src/components/dropdowns/Result.react";

import {
  Table,
  ColHeader,
  TableBody,
  Col,
} from "src/components/tables/Table.react";
import ResultBadge from "src/components/badges/Result.react";

/**
 * The Grease component
 *
 * @author Thais Watanabe
 */
const Grease = (props) => {
  const {
    turbineInspection,
    title,
    inspectionModel,
    result,
    lastResult1,
    lastResult2,
    lastTurbineInspections,
    openEdit,
    openObs,
    inspection,
  } = props;

  return (
    <Table>
      <thead>
        <tr>
          <ColHeader className="text-center" colSpan={19}>
            {title}
          </ColHeader>
        </tr>
        <tr>
          <ColHeader id={inspectionModel?.name} className="w-10 text-center print:hidden">
            <ResultDropdown
              openEdit={openEdit}
              openObs={openObs}
              selectedItem={inspectionModel}
              turbineInspection={turbineInspection}
              selectedResult={result}
              lastTurbineInspections={lastTurbineInspections}
              inspection={inspection}
            />
          </ColHeader>
          <ColHeader className="text-center" colSpan={2}>
            今回
          </ColHeader>
          <ColHeader className="text-center">
            {lastTurbineInspections?.[0]?.inspection.name}
          </ColHeader>
          <ColHeader className="text-center">
            {lastTurbineInspections?.[1]?.inspection.name}
          </ColHeader>
        </tr>
      </thead>
      <TableBody>
        <tr>
          <Col className="text-center print:hidden"></Col>
          <Col className="text-center">前回補充後高さ</Col>
          <Col className="text-center">
            <ResultBadge
              result={result?.childrenResults[3] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[3].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[3] ?? "-",
                3
              )}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={lastResult1?.childrenResults[3] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[3].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                lastResult1?.childrenResults[3] ?? "-",
                3
              )}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={lastResult2?.childrenResults[3] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[3].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                lastResult2?.childrenResults[3] ?? "-",
                3
              )}
            />
          </Col>
        </tr>
        <tr>
          <Col className="text-center print:hidden"></Col>
          <Col className="text-center">補充前高さ</Col>
          <Col className="text-center">
            <ResultBadge
              result={result?.childrenResults[4] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[4].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[4] ?? "-",
                4
              )}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={lastResult1?.childrenResults[4] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[4].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                lastResult1?.childrenResults[4] ?? "-",
                4
              )}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={lastResult2?.childrenResults[4] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[4].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                lastResult2?.childrenResults[4] ?? "-",
                4
              )}
            />
          </Col>
        </tr>
        <tr>
          <Col className="text-center print:hidden"></Col>
          <Col className="text-center">補充後高さ</Col>
          <Col className="text-center">
            <ResultBadge
              result={result?.childrenResults[6] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[6].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[6] ?? "-",
                6
              )}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={lastResult1?.childrenResults[6] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[6].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                lastResult1?.childrenResults[6] ?? "-",
                6
              )}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={lastResult2?.childrenResults[6] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[6].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                lastResult2?.childrenResults[6] ?? "-",
                6
              )}
            />
          </Col>
        </tr>
        <tr>
          <Col className="text-center print:hidden"></Col>
          <Col className="text-center">補充量</Col>
          <Col className="text-center">
            <ResultBadge
              result={result?.childrenResults[7] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[7].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[7] ?? "-",
                7
              )}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={lastResult1?.childrenResults[7] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[7].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                lastResult1?.childrenResults[7] ?? "-",
                7
              )}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={lastResult2?.childrenResults[7] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[7].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                lastResult2?.childrenResults[7] ?? "-",
                7
              )}
            />
          </Col>
        </tr>
        <tr>
          <Col className="text-center print:hidden"></Col>
          <Col className="text-center">消費量</Col>
          <Col className="text-center">
            <ResultBadge
              result={result?.childrenResults[5] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[5].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[5] ?? "-",
                5
              )}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={lastResult1?.childrenResults[5] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[5].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                lastResult1?.childrenResults[5] ?? "-",
                5
              )}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={lastResult2?.childrenResults[5] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[5].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                lastResult2?.childrenResults[5] ?? "-",
                5
              )}
            />
          </Col>
        </tr>
      </TableBody>
    </Table>
  );
};

export default Grease;
